import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancelPage() {
  return (
    <div className="bg-[#0a0a0c] text-[#ecebe4] min-h-screen flex flex-col">
      <nav className="border-b border-[#22242a] px-6 py-4">
        <span className="flex items-center gap-3">
          <img src="/logo.png" alt="The Print Plug logo" className="w-10 h-10 object-contain" />
          <span className="f-disp tracking-wider text-xl uppercase leading-none text-white">
            THE PRINT PLUG<span className="text-[#39ff14]">.</span>
          </span>
        </span>
      </nav>
      <main className="flex-1 flex items-center justify-center px-6 py-24">
        <div className="max-w-lg w-full bg-[#121316] border border-[#22242a] p-8 md:p-12 space-y-6" data-testid="payment-cancel-panel">
          <XCircle size={40} className="text-[#f5b700]" />
          <h1 className="f-disp text-4xl uppercase text-white leading-[0.95]">
            Checkout Cancelled.
          </h1>
          <p className="f-body text-sm text-[#8e929b] leading-relaxed">
            No charge was made. Your stack is still saved in the cart — pick up right where you left off.
          </p>
          <div className="bg-[#0a0a0c] border border-[#22242a] p-4" data-testid="cancel-reasons">
            <p className="f-mono text-[10px] text-[#f5b700] uppercase tracking-widest mb-2">Payment didn't go through?</p>
            <ul className="f-body text-xs text-[#8e929b] space-y-1.5 leading-relaxed">
              <li>— Card declined by your bank (most common)</li>
              <li>— Insufficient funds or a billing-address mismatch</li>
              <li>— The 3-digit security code or expiry was entered wrong</li>
              <li>— Your bank blocked the charge — try another card or Apple&nbsp;Pay / Google&nbsp;Pay</li>
            </ul>
            <p className="f-body text-xs text-[#8e929b] mt-3">
              Still stuck? Message us with the chat bubble or email <a href="mailto:sales@theprintplug.net" className="text-[#39ff14] hover:text-white transition-colors">sales@theprintplug.net</a> — we'll sort it out.
            </p>
          </div>
          <div className="flex flex-col gap-3">
            <Link
              to="/cart"
              data-testid="cancel-back-to-cart"
              className="block text-center f-mono text-xs uppercase tracking-[0.14em] px-8 py-4 bg-[#39ff14] text-black font-bold hover:bg-white transition-colors d1-glow"
            >
              Return to Stack
            </Link>
            <Link
              to="/"
              data-testid="cancel-back-to-store"
              className="block text-center f-mono text-xs uppercase tracking-[0.14em] px-8 py-4 bg-[#22242a] text-white font-bold hover:bg-[#39ff14] hover:text-black transition-colors"
            >
              Back to Catalog
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
}
